import { Text, Tag, List, HStack, Box, ListItem } from '@cdl/heartbeat-react';
import React, { Fragment } from 'react';
import { Diagnostic } from '../types/diagnostic';

interface Props {
  diagnostic: Diagnostic;
}

export const DiagnosticDisplay: React.FC<Props> = ({
  diagnostic: { abnormalities, comment },
}) => {
  return (
    <>
      <Box>
        <Text fontSize='s' fontWeight='semibold'>
          Abnormalities
        </Text>
        {abnormalities?.length > 0 ? (
          <List listStyleType='circle' listStylePos='inside'>
            {abnormalities.map((abnormality) => (
              <ListItem key={abnormality.code}>
                <Text as='span' fontSize='s'>
                  {abnormality.name}
                </Text>
                <HStack spacing='xs' pl='m'>
                  {[
                    abnormality.frequency,
                    abnormality.localization,
                    abnormality.likelihood,
                    abnormality.temporality,
                  ]
                    .filter((modifier) => modifier != null)
                    .map((modifier, i) => (
                      <Tag key={i} size='sm'>
                        {modifier}
                      </Tag>
                    ))}
                </HStack>
              </ListItem>
            ))}
          </List>
        ) : (
          <Text fontSize='s'>No abnormalities</Text>
        )}
      </Box>
      {comment?.length > 0 && (
        <Box>
          <Text fontSize='s' fontWeight='semibold'>
            Comment
          </Text>
          <Text fontSize='s' wordBreak='break-word'>
            {comment}
          </Text>
        </Box>
      )}
    </>
  );
};
